import { Avatar, Box, Card, Checkbox, Chip, Divider, FormControl, Grid, IconButton, InputAdornment, LinearProgress, Link, List, ListItem, Menu, MenuItem, Pagination, Paper, Select, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography } from '@mui/material';
import React, { useRef, useState } from 'react'
import statusIcon from "../../../assets/svg/Check icon.svg"

import { HiOutlineUsers } from 'react-icons/hi';
import { LiaCoinsSolid } from "react-icons/lia";
import { GoGift } from 'react-icons/go';
import { Area, AreaChart, CartesianGrid, Cell, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { ArrowForward, CloseOutlined,} from '@mui/icons-material';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { MdContentCopy, MdNotInterested, MdOutlineModeEdit, MdOutlineRemoveRedEye } from 'react-icons/md';
import CheckIcon from "@mui/icons-material/Check";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { CiCalendar, CiCirclePlus, CiPlay1 } from 'react-icons/ci';
import SearchIcon from "@mui/icons-material/Search";
import { Modal } from 'react-bootstrap';
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";

import { FaArrowCircleUp } from 'react-icons/fa';
import { LuArrowUpDown, LuPencil } from 'react-icons/lu';
import { IoIosArrowRoundForward, IoIosCloseCircle } from 'react-icons/io';


const buildRuleDetails = (row) => ({
    id: row.id,
    name: row.name,
    status: row.status,
    description: row.description ?? "Earn points for every amount spent purchases and services.",
    type: row.type,
    trigger: row.trigger,
    reward: row.reward,
    minimumAmount: row.minimumAmount ?? "1 EGP",
    maxPointsPerTransaction: row.maxPointsPerTransaction ?? "10,000 Points",
    validityPeriod: row.validity,
    applicableTo: row.applicableTo ?? "All Members",
    channels: row.channels ?? "All Channels",
    performance: {
        pointsIssued: row.pointsIssued,
        pointsIssuedGrowth: 18.8,
        membersBenefited: row.memberBenefited,
        membersBenefitedGrowth: 15,
        transactions: row.transactions ?? "45,860",
        transactionsGrowth: 12,
    },
});

const mockMembers = [
    { name: "Ahmed Mohamed", id: "10045", date: "Jul 15, 2026 - 02:35 pm", earnedPoints: 250, transactionId: "TXN-584125" },
    { name: "Ahmed Mohamed", id: "10045", date: "Jul 15, 2026 - 02:35 pm", earnedPoints: 250, transactionId: "TXN-584125" },
    { name: "Ahmed Mohamed", id: "10045", date: "Jul 15, 2026 - 02:35 pm", earnedPoints: 250, transactionId: "TXN-584125" },
];

const mockActivityLogs = [
    { kind: "activated", title: "Rule Activated", by: "Ahmed Mohamed", role: "Admin", date: "Jul 15, 2026 - 02:35 pm" },
    { kind: "updated", title: "Rule Updated", description: 'Trigger changed from "Every 10 EGP spent" to "Every 1 EGP spent"', by: "Sara Ahmed", role: "Admin", date: "Jul 15, 2026 - 02:35 pm" },
    { kind: "validity", title: "Validity Updated", description: "End date changed from", fromValue: "Dec 31, 2025", toValue: "Dec 31, 2026", by: "Ahmed Mohamed", role: "Admin", date: "Jul 15, 2026 - 02:35 pm" },
    { kind: "resumed", title: "Tier Resumed", by: "Ahmed Mohamed", role: "Admin", date: "Jul 15, 2026 - 02:35 pm" },
    { kind: "updated", title: "Rule Updated", description: 'Trigger changed from "Every 10 EGP spent" to "Every 1 EGP spent"', by: "Sara Ahmed", role: "Admin", date: "Jul 15, 2026 - 02:35 pm" },
];

const activityIconMap = {
    activated: { icon: <CiCirclePlus size={25}/>, color: "#3FBEAC", bg: "#ECF9F7" },
    updated: { icon: <LuPencil size={25}/>, color: "#7E1BAD", bg: "#F6E9FC" },
    validity: { icon: <CiCalendar size={25}/>, color: "#7E1BAD", bg: "#F6E9FC" },
    resumed: { icon: <CiPlay1 size={25}/>, color: "#04B22E", bg: "#F4F8F0" },
};

function InfoField({ label, value, }) {
    return (
        <Grid item xs={12}>
            <Typography sx={{ fontSize: 12, color: "#535353", my: 0.3}}>{label}</Typography>
            <Typography sx={{ fontSize: 14, }}>{value}</Typography>
        </Grid>
    );
}



function RuleOverviewTab({ rule }) {
    return (
        <Box>
            <Typography sx={{ fontSize: 15, fontWeight: 700, my: 1 }}>Rule Information</Typography>
            <Grid container spacing={3}>
                <InfoField label="Description" value={rule.description} />
                <InfoField label="Type" value={rule.type} />
                <InfoField label="Trigger" value={rule.trigger} />
                <InfoField label="Reward" value={rule.reward} />
                <InfoField label="Minimum Amount" value={rule.minimumAmount} />
                <InfoField label="Maximum Points Per Transaction" value={rule.maxPointsPerTransaction} />
                <InfoField label="Validity Period" value={rule.validityPeriod} />
                <InfoField label="Applicable To" value={rule.applicableTo} />
                <InfoField label="Channels" value={rule.channels} />
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Typography sx={{ fontSize: 15, fontWeight: 600, mb: 2 }}>Performance</Typography>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                   <Box sx={{ flex: 1, p: 1, textAlign:"center" }}>
            <Typography sx={{ fontSize: 12, color: "#535353", mb: 0.5 }}>Points Issued</Typography>
            <Typography sx={{ fontSize: 20, fontWeight: 700 }}>{rule.performance.pointsIssued}</Typography>
            {rule.performance.pointsIssuedGrowth != null && (
                <Typography sx={{ fontSize: 12, color: "#3FBEAC", mt: 0.5 }}><FaArrowCircleUp/> {rule.performance.pointsIssuedGrowth}%</Typography>
            )}
        </Box>
        <Divider orientation='vertical' flexItem/>
                   <Box sx={{ flex: 1, p: 1 , textAlign:"center"}}>
            <Typography sx={{ fontSize: 12, color: "#535353", mb: 0.5 }}>Members Benefited</Typography>
            <Typography sx={{ fontSize: 20, fontWeight: 700 }}>{rule.performance.membersBenefited}</Typography>
            {rule.performance.membersBenefitedGrowth != null && (
                <Typography sx={{ fontSize: 12, color: "#3FBEAC", mt: 0.5 }}> <FaArrowCircleUp/> {rule.performance.membersBenefitedGrowth}%</Typography>
            )}
        </Box>
        <Divider orientation='vertical' flexItem/>
                   <Box sx={{ flex: 1, p: 1 , textAlign:"center"}}>
            <Typography sx={{ fontSize: 12, color: "#535353", mb: 0.5 }}>Transactions</Typography>
            <Typography sx={{ fontSize: 20, fontWeight: 700 }}>{rule.performance.transactions}</Typography>
            {rule.performance.transactionsGrowth != null && (
                <Typography sx={{ fontSize: 12, color: "#3FBEAC", mt: 0.5 }}> <FaArrowCircleUp/> {rule.performance.transactionsGrowth}%</Typography>
            )}
        </Box>
                {/* <StatCard label="Points Issued" value={rule.performance.pointsIssued} growth={rule.performance.pointsIssuedGrowth} />
                <StatCard label="Members Benefited" value={rule.performance.membersBenefited} growth={rule.performance.membersBenefitedGrowth} />
                <StatCard label="Transactions" value={rule.performance.transactions} growth={rule.performance.transactionsGrowth} /> */}
            </Box>
        </Box>
    );
}

function RuleBenefitedMembersTab({ members, total, page, onPageChange }) {
    const [dateOpen, setDateOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const dateButtonRef = useRef(null);
 
    return (
        <Box>
            <Typography sx={{ fontSize: 15, fontWeight: 700, mb: 2 }}>Benefited Members</Typography>
 
            <Box display="flex" alignItems="center" gap={1} sx={{ mb: 2 }}>
                <TextField
                    size="small"
                    placeholder="Search members.."
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 }, flex: 1 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchIcon fontSize="small" sx={{ color: "#9A9A9A" }} />
                            </InputAdornment>
                        ),
                    }}
                />
 
                <IconButton
                disableRipple
                    ref={dateButtonRef}
                    onClick={() => setDateOpen(true)}
                    sx={{
                        border: "1px solid #E8E8E8",
                        borderRadius: 2,
                        width: 40,
                        height: 40,
                    }}
                >
                    <CiCalendar  color= {"#535353"} />
                </IconButton>
 
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        open={dateOpen}
                        onClose={() => setDateOpen(false)}
                        value={selectedDate}
                        onChange={(newValue) => {
                            setSelectedDate(newValue);
                            setDateOpen(false);
                        }}
                        slots={{ textField: () => null }}
                        slotProps={{ popper: { anchorEl: dateButtonRef.current, placement: "bottom-end" } }}
                    />
                </LocalizationProvider>
                <IconButton
                disableRipple
                     sx={{
                        border: "1px solid #E8E8E8",
                        borderRadius: 2,
                        width: 40,
                        height: 40,
                    }}>
                        
                        <LuArrowUpDown color='#535353'/>
                    </IconButton>
            </Box>
 
            <Box sx={{ maxHeight: 380, overflowY: "auto", pr: 0.5 }}>
                {members.map((member, idx) => (
                    <Box key={idx} sx={{ border: "1px solid #F0F0F0", borderRadius: 2, p: 2, mb: 1.5 }}>
                        <Box sx={{ display: "flex", alignItems: "start", gap: 1.5, mb: 1.5 }}>
                            <Avatar sx={{ width: 36, height: 36 }} />
                            <Box>
                                <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{member.name}</Typography>
                                <Typography sx={{ fontSize: 12, color: "#535353", my:.5 }}>ID: {member.id}</Typography>
                                   <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 , my:.5}}>
                                <CiCalendar  color= {"#535353"} />
                                <Typography sx={{ fontSize: 12, color: "#535353" }}>{member.date}</Typography>
                            </Box>
                            </Box>
                         
                        </Box>
 
                        <Box sx={{ display: "flex", bgcolor: "#ECF9F780", borderRadius: 1.5, p: 1.5,  }}>
                            <Box sx={{ flex: 1 , textAlign:"center"}}>
                                <Typography sx={{ fontSize: 12, color: "#8A8A8A" }}>Earned Points</Typography>
                                <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{member.earnedPoints}</Typography>
                            </Box>
                            <Divider orientation='vertical' flexItem/>
                            <Box sx={{ flex: 1, textAlign:"center" }}>
                                <Typography sx={{ fontSize: 12, color: "#8A8A8A" }}>Transaction ID</Typography>
                                <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{member.transactionId}</Typography>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Box>
 
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 2, flexWrap: "wrap", gap: 1 }}>
                <Typography sx={{ fontSize: 12, color: "#8A8A8A" }}>
                    Showing {members.length} of {total} members
                </Typography>
                <Pagination
                    count={Math.max(1, Math.ceil(total / (members.length || 1)))}
                    page={page}
                    onChange={(_, value) => onPageChange(value)}
                    shape="rounded"
                    size="small"
                />
            </Box>
        </Box>
    );
}
 



function RuleActivityLogTab({ logs, filter, onFilterChange }) {
    const filteredLogs = filter === "all" ? logs : logs.filter((l) => l.kind === filter);
 
    return (
        <Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2, gap: 1, borderBottom:"1px solid #E8E8E8", py:1 }}>
                <Typography sx={{ fontSize: 15, fontWeight: 700 }}>Activity Log</Typography>
                <FormControl size="small" sx={{ minWidth: 150, "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13 } }}>
                    <Select value={filter} onChange={(e) => onFilterChange(e.target.value)} IconComponent={KeyboardArrowDownIcon}>
                        <MenuItem value="all">All Activities</MenuItem>
                        <MenuItem value="updated">Rule Updated</MenuItem>
                        <MenuItem value="validity">Validity Updated</MenuItem>
                    </Select>
                </FormControl>
            </Box>
 
            <Box sx={{ maxHeight: 420, overflowY: "auto", pr: 0.5 }}>
                {filteredLogs.map((log, idx) => {
                    const meta = activityIconMap[log.kind] || activityIconMap.updated;
                    const isLast = idx === filteredLogs.length - 1;
                    return (
 
                        <Box key={idx} sx={{ display: "flex", gap: 1.5 }}>
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <Box sx={{ width: 40, height: 40, borderRadius: "50%", bgcolor: meta.bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                    <Box color={meta.color}>
                                        {meta.icon}
                                    </Box>
                                </Box>
                                {!isLast && (
                                    <Box sx={{ flex: 1, width: "1px", bgcolor: "#E8E8E8", my: 0.5, minHeight: 20 }} />
                                )}
                            </Box>
 
                            <Box width={"100%"} sx={{ pb: 2.5 }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 , }}>
                                    <Box>
                                        <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{log.title}</Typography>
                                              {log.description && (
                                    <Typography sx={{ fontSize: 12, color: "#5A5A5A", }}>{log.description}</Typography>
                                )}
 
                                {log.fromValue && log.toValue && (
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                                        <Chip label={log.fromValue} size="small" sx={{ bgcolor: "#FAFAFA", border: "1px solid #EEE" , borderRadius:3}} />
                                        <IoIosArrowRoundForward size={18} color='#535353'/>
                                        <Chip label={log.toValue} size="small" sx={{ bgcolor: "#FAFAFA", border: "1px solid #EEE" }} />
                                    </Box>
                                )}
                                   <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.8 }}>
                                    <CalendarTodayOutlinedIcon sx={{ fontSize: 13, color: "#9A9A9A" }} />
                                    <Typography sx={{ fontSize: 12, color: "#8A8A8A" }}>{log.date}</Typography>
                                </Box>
 
                                    </Box>
                                    <Box sx={{display:"flex", flexDirection:"column", justifyContent:"center", }}>
                                        <Typography sx={{ fontSize: 12, color: "#8A8A8A" }}>by {log.by}</Typography>
                                        <Chip label={log.role} size="small" sx={{ bgcolor: "#ECF9F7", fontSize: 11, height: 20,  }} />
                                    </Box>
                                </Box>
 
                          
                             
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}
const PointsRules = () => {


    const Stats = [
        { title: "Total Rules", value: 27, subtitle: "All rules" },
        { title: "Active rules", value: 18, subtitle: "66.7% of total" },
        { title: "Scheduled Rules", value: 6, subtitle: "22.2% of total" },
        { title: "Disabled Rules", value: 3, subtitle: "11.1% of total" },

    ];

    const RulesPerformance = [
        { name: "Points Issued", text: "12.4M", icon: <GoGift />, bg: "#ECF9F7", color: "#3FBEAC", description: "18% vs last 30 days" },
        { name: "Benefited Members", text: "24,568", icon: <HiOutlineUsers />, bg: "#FFFAEA", color: "#FEB91E", description: "18% vs last 30 days" },
        { name: "Top Performing Rule", text: "459K", icon: <LiaCoinsSolid />, bg: "#ECF9F7", color: "#3FBEAC", description: "18% vs last 30 days" },
    ];

    const RulesDistributionDonut = [
        { name: "Spend Rules", value: 9, color: "#3FBEAC" },
        { name: "Referral Rules", value: 5, color: "#7E1BAD" },
        { name: "Purchase Rules", value: 4, color: "#ECB541" },
        { name: "Tier Rules", value: 3, color: "#3E9FF6" },
        { name: "Promotional Rules", value: 3, color: "#FC6C4F" },
        { name: "Tier Rules", value: 3, color: "#696969" },
    ];

    const total = RulesDistributionDonut.reduce((sum, item) => sum + item.value, 0);

     const TopPerformingRules = [
            { name: "Spend & Earn", value: "8.2M", progressValue: 80 },
            { name: "Double Points Friday", value: "1.6M", progressValue: 30  },
            { name: "Referral Bonus", value: "1.2M", progressValue: 20},
            { name: "First Order Bonus", value: "850K", progressValue: 10},
            { name: "Battery Category Bouns", value: "650K", progressValue: 5},
        ];
      const data = [
    { date: "Apr 22", value: 430000 }, { date: "Apr 23", value: 445000 }, { date: "Apr 24", value: 470000 },
    { date: "Apr 25", value: 560000 }, { date: "Apr 26", value: 750000 }, { date: "Apr 27", value: 1050000 },
    { date: "Apr 28", value: 1450000 }, { date: "Apr 29", value: 1750000 }, { date: "Apr 30", value: 1850000 },
    { date: "May 01", value: 1800000 }, { date: "May 02", value: 1550000 }, { date: "May 03", value: 1200000 },
    { date: "May 04", value: 900000 }, { date: "May 05", value: 700000 }, { date: "May 06", value: 580000 },
    { date: "May 07", value: 560000 }, { date: "May 08", value: 650000 }, { date: "May 09", value: 900000 },
    { date: "May 10", value: 850000 }, { date: "May 11", value: 650000 }, { date: "May 12", value: 560000 },
    { date: "May 13", value: 580000 }, { date: "May 14", value: 750000 }, { date: "May 15", value: 1100000 },
    { date: "May 16", value: 1450000 }, { date: "May 17", value: 1400000 }, { date: "May 18", value: 1000000 },
    { date: "May 19", value: 650000 }, { date: "May 20", value: 400000 }, { date: "May 21", value: 350000 },
    { date: "May 22", value: 380000 }, { date: "May 23", value: 420000 }, { date: "May 24", value: 600000 },
];

const visibleTicks = ["Apr 22", "Apr 29", "May 06", "May 13", "May 20"];

    const [selectedRows, setSelectedRows] = useState([]);
  
    const [selectedInfoRows, setSelectedInfoRows] = useState([]);

    

    const rows = [
        {
            id: "PR-001", name: "Spend & Earn", type: "Spend Rule", trigger: "Every 1 EGP spent",
            reward: "1 Point", memberBenefited: "18,250", pointsIssued: "8.2M", validity: "Mar 10 - May 31, 2025",
            status: { name: "Active", color: "#3FBEAC", bgColor: "#ECF9F7",},
            lastUpdate: "2h ago Mona Ali",
        },
        {
            id: "PR-002", name: "Double Points Friday", type: "Promotional Rule", trigger: "Every Friday",
            reward: "2x Points", memberBenefited: "9,860", pointsIssued: "1.6M", validity: "Mar 10 - May 31, 2025",
            status: { name: "Active", color: "#3FBEAC", bgColor: "#ECF9F7",},
            lastUpdate: "2h ago Mona Ali",
        },
        {
            id: "PR-003", name: "Referral Bonus", type: "Referral Rule", trigger: "500 Points",
            reward: "500 Points", memberBenefited: "4,320", pointsIssued: "8.2M", validity: "Mar 10 - May 31, 2025",
            status: { name: "Active", color: "#3FBEAC", bgColor: "#ECF9F7",},
            lastUpdate: "2h ago Mona Ali",
        },
     
    ];

    // const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [menuState, setMenuState] = useState({ anchorEl: null, row: null });
    const [menuDetailsState, setMenuDetailsState] = useState({ anchorEl: null, row: null });

    const handleClose = () => setMenuState({ anchorEl: null, row: null });
    // const handleCloseMenuDetails = () => setMenuState({ anchorEl: null,  });
    const handleClick = (event, row) => setMenuState({ anchorEl: event.currentTarget, row });
    // const handleClickMenuDetails = (event) => setMenuDetailsState({ anchorEl: event.currentTarget});

    const handleActivate = () => console.log(selectedRows);
   const handleReset = () => {
    setSelectedInfoRows([]);
};
    const handleDelete = () => console.log(selectedRows);

    // ---- Rule Details modal state ----
    const [viewDetailsShow, setViewDetailsShow] = useState(false);
    const [selectedRuleDetails, setSelectedRuleDetails] = useState(null);
    const [detailsTab, setDetailsTab] = useState(0);
    const [activityFilter, setActivityFilter] = useState("all");
    const [membersPage, setMembersPage] = useState(1);

    const pointsRulesDetailsShow = (row) => {
        handleClose(); // close the 3-dot menu
        setSelectedRuleDetails(buildRuleDetails(row));
        setDetailsTab(0);
        setActivityFilter("all");
        setMembersPage(1);
        setViewDetailsShow(true);
    };

    const pointsRulesDetailsClose = () => {
        setViewDetailsShow(false);
        setSelectedRuleDetails(null);
    };

    return (
        <>
           <Modal
          show={viewDetailsShow}
          onHide={pointsRulesDetailsClose}
          dialogClassName="custom-modal-campaigns-width mt-0"
        >
          <Modal.Body className="mx-1">
       {/* Points Rules Details */}
       {selectedRuleDetails && (
           <Box sx={{ p: 1 }}>
               <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                   <Typography sx={{ fontSize: 18, fontWeight: 600 }}>Rule Details</Typography>
             <IconButton disableRipple onClick={pointsRulesDetailsClose}>
                     <IoIosCloseCircle color="#535353" size={"30px"} />
                   </IconButton>
               </Box>
 <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
<Box>
             <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
                   <Typography sx={{ fontSize: 16, fontWeight: 600 }}>{selectedRuleDetails.name}</Typography>
                   <Chip
                       label={selectedRuleDetails.status.name}
                       size="small"
                       sx={{ bgcolor: selectedRuleDetails.status?.bgColor, fontWeight: 500, px:1 }}
                   />
               </Box>
               <Typography sx={{ fontSize: 12, color: "#535353", mt: 0.3 }}>
                   Rule ID: {selectedRuleDetails.id}
               </Typography>

</Box>
<Box>
                        <IconButton
                        disableRipple
                        size="small"
                        // onClick={(e) => {
                        //     handleClickMenuDetails(e);
                        //     e.stopPropagation();
                        // }}
                    >
                        <MoreVertIcon fontSize="small" />
                    </IconButton>
                    {/* <Menu
                        anchorEl={menuDetailsState.anchorEl}
                        open={Boolean(menuDetailsState.anchorEl)}
                        onClose={handleCloseMenuDetails}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        slotProps={{ paper: { sx: { borderRadius: 2, p: 1, backgroundColor: "#F9F9F9" } } }}
                    >
                 
                        <MenuItem className="p-1" sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#000" }}>
                            <MdOutlineModeEdit size={18} /> Edit
                        </MenuItem>
                       
                     
                        <MenuItem className="p-1" sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#000" }}>
                            <MdContentCopy size={18}/> Duplicate
                        </MenuItem>
                        <MenuItem className="p-1" sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#A80101" }}>
                            <MdNotInterested size={18}/> Disable
                        </MenuItem>
                    </Menu> */}
</Box>
 </Box>
      
             <Box className="custom-tab-style">
                  <Tabs
                   value={detailsTab}
                   onChange={(_, value) => setDetailsTab(value)}
                   variant="scrollable"
                   scrollButtons="auto"
                   TabIndicatorProps={{ sx: { backgroundColor: "#3FBEAC", height: "3px" } }}
                   sx={{
                       mt: 2,
                       minHeight: 36,
                       "& .MuiTab-root": { textTransform: "none", fontSize: 13, fontWeight: 500, minHeight: 36, px: 1.5 },
                   }}
               >
                   <Tab label="Overview" />
                   <Tab label="Benefited Members" />
                   <Tab label="Activity Log" />
               </Tabs>
               <Divider />

               <Box sx={{ pt: 3 }}>
                   {detailsTab === 0 && <RuleOverviewTab rule={selectedRuleDetails} />}
                   {detailsTab === 1 && (
                       <RuleBenefitedMembersTab
                           members={mockMembers}
                           total={4200}
                           page={membersPage}
                           onPageChange={setMembersPage}
                       />
                   )}
                   {detailsTab === 2 && (
                       <RuleActivityLogTab
                           logs={mockActivityLogs}
                           filter={activityFilter}
                           onFilterChange={setActivityFilter}
                       />
                   )}
               </Box>
             </Box>
           </Box>
       )}
          </Modal.Body>
        </Modal>
            <Box>
                <Grid container spacing={2} sx={{ py: 3 }} alignItems="stretch">
                    {Stats.map((item) => (
                        <Grid item xs={12} sm={6} md={3} key={item.title} sx={{ display: "flex" }}>
                            <Card
                                elevation={0}
                                sx={{
                                    border: "1px solid #ECECEC",
                                    boxShadow: "0px 1px 4px rgba(0,0,0,0.04)",
                                    borderRadius: 3,
                                    px: 2.5,
                                    py: 2,
                                    width: "100%",
                                }}
                            >
                                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                                    <Box component="img" src={statusIcon} alt="status" sx={{ width: 24, height: 24 }} />
                                    <Typography fontWeight={600} fontSize={14}>{item.title}</Typography>
                                </Box>
                                <Typography fontWeight={700} fontSize={22} sx={{ mt: 1 }}>{item.value}</Typography>
                                <Typography color="text.secondary" fontSize={12}>{item.subtitle}</Typography>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
                <Card elevation={0} sx={{ border: "1px solid #ECECEC", borderRadius: 4, p: 3, mb: 2 }}>
                    <Box sx={{ py: 1, borderBottom: "1px solid #ECECEC", mb: 1 }}>
                        <Typography fontWeight={600}>
                            Rules Performance <Typography component="span" color="text.secondary" fontSize={13}>(Last 30 Days)</Typography>
                        </Typography>
                    </Box>

                    <Grid container spacing={3}>
                        {RulesPerformance.map((item, i, arr) => (
                            <Grid item xs={12} sm={6} md={4} key={item.name}  >
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: 2,
                                        alignItems: "center",
                                        height: "100%",
                                        pr: { md: i < arr.length - 1 ? 3 : 0 },
                                        borderInlineEnd: { md: i < arr.length - 1 ? "1px solid #E8E8E8" : "none" },
                                        justifyContent: "center",
                                        my: 1
                                    }}
                                >
                                    <Avatar sx={{ bgcolor: item.bg, color: item.color, flexShrink: 0 }}>{item.icon}</Avatar>
                                    <Box sx={{ minWidth: 0 }}>
                                        <Typography color="text.secondary" fontSize={12} noWrap>{item.name}</Typography>
                                        <Typography fontSize={14} fontWeight={600} noWrap>{item.text}</Typography>
                                        <Typography fontSize={12} color="text.secondary" noWrap>{item.description}</Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>


                </Card>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <Card
                            elevation={0}
                            sx={{
                                border: "1px solid #ECECEC",
                                borderRadius: 3,
                                p: 2,
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                height: { xs: "auto", md: 350 },

                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    borderBottom: "1px solid #ECECEC",
                                    pb: 1.5,
                                    mb: 1,
                                    flexWrap: "wrap",
                                    gap: 1,
                                }}
                            >
                                <Typography fontWeight={600} fontSize={14}>Rules Distribution by Type</Typography>


                            </Box>
                            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
                                <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 2, flexGrow: 1 }}>
                                    <Box sx={{ width: 160, height: 160, flexShrink: 0 }}>
                                        <ResponsiveContainer>
                                            <PieChart>
                                                <Pie data={RulesDistributionDonut} dataKey="value" innerRadius={55} outerRadius={78} startAngle={90} endAngle={-270}>
                                                    {RulesDistributionDonut.map((item) => (<Cell key={item.name} fill={item.color} />))}
                                                </Pie>
                                                <text x="50%" y="50%" textAnchor="middle" fontSize="28" fontWeight="700">{Number(total).toLocaleString("en-Us")}</text>
                                                <text x="50%" y="62%" textAnchor="middle" fontSize="13">Total</text>
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </Box>

                                    <Box sx={{ flexGrow: 1, minWidth: 140 }}>
                                        {RulesDistributionDonut.map((item) => (
                                            <Box>
                                                <Box key={item.name} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", my: 2 }}>
                                                 <Box display={"flex"} alignItems={"center"} gap={.5}>
                                               <Box sx={{ width: 9, height: 9, borderRadius: "50%", bgcolor: item.color, flexShrink: 0 }} />
                                                    <Typography fontSize={12.5} noWrap>
                                                        {item.name}
                                                    </Typography></Box>
                                                    <Box>
                                                        <Typography fontSize={12} color='#535353' fontWeight={400}>   {item.value}  ({((item.value / total) * 100).toFixed(1)}%)</Typography>
                                                    </Box>
                                                </Box>

                                            </Box>

                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                                               <Card
                                elevation={0}
                                sx={{
                                    border: "1px solid #ECECEC",
                                    borderRadius: 3,
                                    py: 2,
                                    px:3,
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    height: { xs: "auto", md: 350},
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        borderBottom: "1px solid #ECECEC",
                                        pb: 1.5,
                                        mb: 1,
                                        flexWrap: "wrap",
                                        gap: 1,
                                    }}
                                >
                                    <Typography fontWeight={600} fontSize={14}>Top Performing Rules</Typography>
                                        <Link sx={{ color: "#159D89", textDecorationLine: "none", fontSize: 13, display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}>
                                            View all <ArrowForward sx={{ fontSize: 14 }} />
                                        </Link>
                                    
                                </Box>
                                <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
                                         <List sx={{ py: 0 }}>
                                                            {TopPerformingRules.map((s, i) => (
                                                                <ListItem key={s.name} sx={{ borderBottom: i < TopPerformingRules.length - 1 ? "1px solid #E8E8E8" : "none", px: 0 }}>
                                                                    <Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: 1.5, py: 2 }}>
                                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0, minWidth: 130 }}>
                                                                            <Box sx={{ width: 23, height: 23, borderRadius: "50%", bgcolor: "#E8E8E8",color:"#535353", display: "flex", alignItems: "center", justifyContent: "center", fontWeight:"400", fontSize:12 }}>
                                                                                {i + 1}
                                                                            </Box>
                                                                            <Typography fontSize={12.5} noWrap>{s.name}</Typography>
                                                                        </Box>
                                                                        <LinearProgress
                                                                            variant="determinate"
                                                                            value={s.progressValue}
                                                                            sx={{ height: 7, borderRadius: 4, backgroundColor: "#DADADA", flex: 1, "& .MuiLinearProgress-bar": { backgroundColor: "#3FBEAC", borderRadius: 10 } }}
                                                                        />
                                                                        <Typography fontSize={13} sx={{ width: 32, flexShrink: 0, textAlign: "right" }}>{s.value}</Typography>
                                                                    </Box>
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                </Box>
                            </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                                 <Card
                        elevation={0}
                        sx={{
                            border: "1px solid #ECECEC",
                            borderRadius: 3,
                            p: 2,
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                           height: { xs: "auto", md: 350 },
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderBottom: "1px solid #ECECEC",
                                pb: 1.5,
                                mb: 1,
                            }}
                        >
                            <Typography fontWeight={600} fontSize={14}>Points Issued Trend ( Last 30 Days)</Typography>
                                 <Box sx={{ display: "flex", justifyContent: "flex-end"}}>
                                            <FormControl size="small" sx={{ "& .MuiOutlinedInput-root": { borderRadius: "6px", fontSize: 13 } }}>
                                                <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                                                    <MenuItem value="all">Last 30 Days</MenuItem>
                                                    <MenuItem value="active">Last 20 Days</MenuItem>
                                                    <MenuItem value="inactive">Last 10 Days</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                            
                        </Box>
                        <Box >
                          
                
                                        <Box sx={{ width: "100%", height: 270 }}>
                                 <ResponsiveContainer>
    <AreaChart data={data}>
        <defs>
            <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#3FBEAC" stopOpacity={0.25} />
                <stop offset="95%" stopColor="#34B3F1" stopOpacity={0} />
            </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="date" ticks={visibleTicks} interval={0} axisLine={false} tickLine={false} />
      <YAxis
    domain={[0, 2000000]}
    ticks={[0, 500000,1000000, 1500000,  2000000]}
    tickFormatter={(v) => (v >= 1000000 ? `${v / 1000000}M` : `${v / 1000}K`)}
    axisLine={false}
    tickLine={false}
/>
        <Tooltip />
        <Area type="monotone" dataKey="value" stroke="#46C1B6" strokeWidth={4} fill="url(#colorValue)" />
    </AreaChart>
</ResponsiveContainer>
                                        </Box>
                        </Box>
                    </Card>
                    </Grid>
                </Grid>
            

                          <Grid container spacing={2} alignItems="end" justifyContent={"space-between"}  sx={{ my: 1, pb: 3, }}>
                                            <Grid item xs={12} md={3}>
                                    <Typography fontSize={16} fontWeight={600} my={1}>All Points Rules</Typography>
                                       <TextField
                                                                            placeholder="Search by name, phone or email"
                                                                            size="small"
                                                                            fullWidth
                                                                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff" }, }}
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <InputAdornment position="end">
                                                                                        <SearchIcon sx={{ color: "#888", fontSize: 20 }} />
                                                                                    </InputAdornment>
                                                                                ),
                                                                            }}
                                                                        />
                                            </Grid>
                                            <Grid item xs={12} md={9} >
                                                <Grid container spacing={2} justifyContent={"end"}  >
                                                    <Grid item xs={12} md={2} >
                                                <Typography color="text.secondary" fontSize={13} sx={{ mb: 0.5 }}>Rule Type</Typography>
                                                <FormControl size="small" fullWidth sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: 14 } }}>
                                                    <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                                                        <MenuItem value="all">All </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                            
                                            <Grid item xs={12} md={2}>
                                                <Typography color="text.secondary" fontSize={13} sx={{ mb: 0.5 }}>Points Issued</Typography>
                                                <FormControl size="small" fullWidth sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: 14 } }}>
                                                    <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                                                        <MenuItem value="all">All</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                            
                                            <Grid item xs={12}  md={2}>
                                                <Typography color="text.secondary" fontSize={13} sx={{ mb: 0.5 }}>Trigger</Typography>
                                                <FormControl size="small" fullWidth sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: 14 } }}>
                                                    <Select defaultValue="all" IconComponent={KeyboardArrowDownIcon}>
                                                        <MenuItem value="all">All</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                            
                                            <Grid item xs={12}  md={3}>
                                                <Typography color="text.secondary" fontSize={13} sx={{ mb: 0.5 }}>Date Range</Typography>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DemoContainer components={["DatePicker"]} sx={{ pt: 0, "& .MuiFormControl-root": { width: "100%" } }}>
                                                        <DatePicker
                                                            sx={{ width: "100%", "& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: 14, overflow:"hidden" } }}
                                                            format="DD,MM,YYYY"
                                                            slotProps={{ textField: { size: "small", placeholder: "Select Date", fullWidth: true } }}
                                                        />
                                                    </DemoContainer>
                                                </LocalizationProvider>
                                            </Grid>
                                                </Grid>
                                            </Grid>
                           
                                        
                                        </Grid>
                                             <Box sx={{ borderColor: "divider", my:2 , display:"flex", justifyContent:"space-between" , alignItems:"center",borderBottom:"1px solid #D8D8D8"}}>
             <Box  className='custom-tab-style' >
                   <Tabs
                    value={0}
                    variant="scrollable"
                    scrollButtons="auto"
                    TabIndicatorProps={{ sx: { backgroundColor: "#3FBEAC", height: "3px" } }}
                >
                    {[
                        { label: "All Rules", count: 27, active: true },
                        { label: "Active", count: 18 },
                        { label: "Scheduled", count: 6 },
                        { label: "Disabled", count: 3 },
                    ].map((tab) => (
                        <Tab
                            key={tab.label}
                            sx={{ textTransform: "capitalize", fontSize: 14 }}
                            label={
                                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                                    <Typography fontSize={14} component="span">{tab.label}</Typography>
                                    <Chip
                                        sx={{ color: tab.active ? "#fff" : "#535353", bgcolor: tab.active ? "#3FBEAC" : "#E8E8E8", fontSize: 12 }}
                                        label={tab.count}
                                    />
                                </Box>
                            }
                        />
                    ))}
                </Tabs>
             </Box>
                     {selectedInfoRows.length > 0 && (
                        <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-end", alignItems: "center", gap: 2 }}>
                            <Box display="flex" alignItems="center">
                                <Checkbox
                                    checked
                                    checkedIcon={
                                        <Box sx={{ width: 22, height: 22, borderRadius: 1, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#000" }}>
                                            <CheckIcon sx={{ color: "#fff", fontSize: 18 }} />
                                        </Box>
                                    }
                                    size="small"
                                />
                                <Typography fontSize={14}>{selectedInfoRows.length} selected</Typography>
                            </Box>

                            <Divider orientation="vertical" flexItem sx={{ borderColor: "#BCBCBC" }} />

                            <Typography fontSize={14}>Bulk actions:</Typography>

                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                <button style={{ border: "1px solid #04B22E33", fontSize: 14 , color: "#04B22E"}} className="btn px-3 d-flex align-items-center gap-1" onClick={handleActivate}>
                                    <CiPlay1 /> Activate
                                </button>
                             
                                <button style={{ border: "1px solid #A8010133", fontSize: 14, color: "#A80101"}} className="btn px-3 d-flex align-items-center gap-1" onClick={handleDelete}>
                                    <MdNotInterested   /> Disable
                                </button>
                            </Stack>

                            <Divider orientation="vertical" flexItem sx={{ borderColor: "#BCBCBC" }} />

                            <button style={{ color: "#535353", fontSize: 14 }} className="btn btn-outline-light px-3 d-flex align-items-center gap-1" onClick={handleReset}>
                                <CloseOutlined sx={{ color: "#535353" }} /> Clear Selection
                            </button>
                        </Box>
                    )}
            </Box>

         
                <TableContainer
                  component={Paper}
                  elevation={0}
                  sx={{
                    width: "100%",
                    overflowX: "auto",
                    my:1,
                  }}
                >
                  <Table
                    sx={{
                      minWidth: 700,
                       minHeight:"100%",
                      "& .MuiTableCell-root": {
                        fontSize: 13,
                        whiteSpace: "nowrap",
                        borderBottom: "1px solid #F0F0F0",
                      },
            
                      "& .MuiTableHead-root .MuiTableCell-root": {
                        fontSize: 14,
                        fontWeight: 600,
                        color: "#333",
                        backgroundColor: "#FAFAFA",
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{textAlign:"center", width:50}}>ID</TableCell>
                        <TableCell sx={{textAlign:"center", width:100}}>Rule Name</TableCell>
                        <TableCell sx={{textAlign:"center", width:100}}>Type</TableCell>
                        <TableCell sx={{textAlign:"center", width:90}}>Trigger</TableCell>
                        <TableCell sx={{textAlign:"center", width:90}}>Reward</TableCell>
                        <TableCell sx={{textAlign:"center", width:90}}>Member Benefited</TableCell>
                        <TableCell sx={{textAlign:"center", width:100}}>Points Issued</TableCell>
                        <TableCell sx={{textAlign:"center", width:90}}>Status</TableCell>
                        <TableCell sx={{textAlign:"center", width:90}}>Validity</TableCell>
                        <TableCell sx={{textAlign:"center", width:90}}>Action</TableCell>
                      </TableRow>
                    </TableHead>
            
                    <TableBody>
                      {rows.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell sx={{textAlign:"center", width:50}}>
                     <Box display={"flex"} gap={1} alignItems={"center"}>
                  <Checkbox
    checked={selectedInfoRows.some(item => item.id === row.id)}
    onChange={(e) => {
        if (e.target.checked) {
            setSelectedInfoRows(prev => [...prev, row]);
        } else {
            setSelectedInfoRows(prev =>
                prev.filter(item => item.id !== row.id)
            );
        }
    }}
    checkedIcon={
        <Box
            sx={{
                width: 22,
                height: 22,
                borderRadius: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#000"
            }}
        >
            <CheckIcon sx={{ color: "#fff", fontSize: 18 }} />
        </Box>
    }
    size="small"
/>
                       <Typography fontSize={13}>{row.id}</Typography>
                            
                     
                     </Box>
                          </TableCell>
            
                          <TableCell sx={{textAlign:"center", width:50}}>
                      
            
                                {row.name}
                          </TableCell>
            
                          <TableCell sx={{textAlign:"center", width:100}}>
                      {row.type}
                          </TableCell>
            
                          <TableCell sx={{textAlign:"center", width:90}}>
                            {row.trigger}
                          </TableCell>
            
                          <TableCell sx={{textAlign:"center", width:90}}>
                            {row.reward}
                          </TableCell>
            
                          <TableCell sx={{textAlign:"center", width:90}}>
                            {row.memberBenefited}
                          </TableCell>
                          <TableCell sx={{textAlign:"center", width:90}}>
                            {row.pointsIssued}
                          </TableCell>
                          <TableCell sx={{textAlign:"center", width:90}}>
                                <Chip
                            label={row.status.name}
                            size="medium"
                            sx={{ bgcolor: row.status?.bgColor, fontWeight: 500 }}
                        />
                          </TableCell>
                              <TableCell sx={{textAlign:"center", width:100}}>
                      {row.validity}
                          </TableCell>
                          <TableCell sx={{textAlign:"center", width:90}}>
                          
                                <IconButton
                        disableRipple
                        size="small"
                        onClick={(e) => {
                            handleClick(e, row);
                            e.stopPropagation();
                        }}
                    >
                        <MoreVertIcon fontSize="small" />
                    </IconButton>
                    <Menu
                        anchorEl={menuState.anchorEl}
                        open={Boolean(menuState.anchorEl) && menuState.row?.id === row.id}
                        onClose={handleClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        slotProps={{ paper: { sx: { borderRadius: 2, p: 1, backgroundColor: "#F9F9F9" } } }}
                    >
                        <MenuItem onClick={() => pointsRulesDetailsShow(row)} className="p-1" sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#000" }}>
                            <MdOutlineRemoveRedEye size={18} /> View Details
                        </MenuItem>
                        <MenuItem className="p-1" sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#000" }}>
                            <MdOutlineModeEdit size={18} /> Edit
                        </MenuItem>
                       
                     
                        <MenuItem className="p-1" sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#000" }}>
                            <MdContentCopy size={18}/> Duplicate
                        </MenuItem>
                        <MenuItem className="p-1" sx={{ display: "flex", gap: 1, borderRadius: 1, color: "#A80101" }}>
                            <MdNotInterested size={18}/> Disable
                        </MenuItem>
                    </Menu>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
   
            </Box>
        </>
    )
}

export default PointsRules